import styles from './dashboard.module.css'

function HeroWrapper({ title, description, classname, image }) {
    return (
      <div className={`${styles.hero} ${styles.bg} ${classname} px-md-5 px-3 text-white`}>
        <div className={`${styles.content} my-5 d-flex align-items-start`}>
            <div>{image}</div>
            <div>
              <h1 className={`${styles.title} lh-1-5`}><strong>{title}</strong></h1>
              <p className={`${styles.desc} mb-5`}>{description}</p>
            </div>
        </div>
    </div>
    )
  }

export default HeroWrapper;
